function MonsterDigital() {

}

MonsterDigital.uniforms = [
    'Stock NL6010', '2023 Top Next Level 6010 Triblend', 'Lite'
]

MonsterDigital.isMonsterDigital = (uniformId) => {
    // return MonsterDigital.uniforms.includes(+uniformId);
    return _.contains(MonsterDigital.uniforms, ub.config.blockPattern);
}

MonsterDigital.changeColor = (colorCode = ub.current_material.settings.upper['Mascot Guide 1'].colorObj.color_alias) => {
    _.each(ub.views, view => {
        const viewObject = ub.objects[`${view}_view`];
        const settings = ub.current_material.settings[ub.config.type];
        const current_material = ub.current_material.settings;
        const adult_vendor_style = ub.current_material.material.rule.vendor_styles.adult_vendor_style;
        const youth_vendor_style = ub.current_material.material.rule.vendor_styles.youth_vendor_style;

        if (_.isEmpty(viewObject)) return;

        _.each(viewObject, sprite => {
            if (!sprite) return;

            const partName = `${colorCode} ${'flat'} ${view}`.toCodeCase();
            const partNameDrawCord = `${'draw cord'} ${colorCode} ${'flat'} ${'front'}`.toCodeCase();

            if (sprite.name === partNameDrawCord) {
                sprite.zIndex = -300;
            }

            console.log(partName)

            sprite.alpha = sprite.name === partName || sprite.name === partNameDrawCord ? 1 : 0
            
            _.each(settings, obj => {
                obj.alpha = obj.code === partName ? 1 : 0
            })

            // add vendor style in bc
            current_material.adult_vendor_style = adult_vendor_style;
            current_material.youth_vendor_style = youth_vendor_style;
        })  
    })
}